@if (visible) {
  <div class="modal d-block" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content shadow">
        <div class="content">
          <div class="inner-content">
            <div class="header">
              <h3 class="title">{{ dialogTitle }}</h3>
              <span class="subtitle">{{ dialogSubtitle }}</span>
            </div>
          </div>
          <div class="btn-row">
            <button
              appButton="secondary"
              type="button"
              (click)="onNoClicked()"
              >
              Cancel
            </button>
            <button
              type="button"
              appButton
              (click)="onYesClicked()"
              >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
